import { action } from 'typesafe-actions'
import { HANDLE_IS_LOADING, HANDLE_IS_HISTORY_SIDEBAR_OPEN } from './constants'

export const handleIsLoading = (isLoading: boolean) => action(HANDLE_IS_LOADING, isLoading)

export const handleHistorySidebar = (isOpen: boolean) => action(HANDLE_IS_HISTORY_SIDEBAR_OPEN, isOpen)
